export default __webpack_public_path__ + "static/media/house-9.12de1d37.jpg";